/* sv-cart-art.js (store 0.46.6, _preview 0.46.8): every personalised cart line pictures what was actually chosen.

   Tony, 24 Sep 2026, with the cart drawer showing five wooden letters P E T E R all pictured as the sample S: "ensure
   all personalised items when they go into cart reflect exactly what was purchased design and letter or item every
   time otherwise customers will be confused we had this setup we need to sweep again since all the changes today".

   The cart takes a line's picture from the variant or product photo. That is right when the product IS the design
   (the 4,851 one-design products: sacks, stockings, ornaments, mugs, towels, bandanas), and sv-garment.js already
   redraws the garments from _sv_preview. It is wrong in three cases, all drawn here from the line's own properties:

     1 Your Design or Ours (71 products): the photo shows a sample design; the line's design is in _art.
     2 Upload your own, on any product: the photo shows our design; the customer's file is "Your artwork".
     3 Photo blankets: the customer's file is "Photo".

   Each is drawn as the print: the design or the photo, with the name under it in the lettering and colour chosen,
   on the colour of the item where the variant names one (same list as sv-anyart.js). Wooden letters draw the letter or shape bought, filled the
   way it prints (a pattern on a letter, one design and the name on Heart, Star and Hexagon), matching sv-anyart.js
   and fulfil_anyart.py. The drawing replaces the thumbnail on the cart page and in the drawer. */
(function () {
  if (window.__svCartArt) return; window.__svCartArt = true;

  var FACES = { Bold: 'Luckiest Guy', Comic: 'Bangers', Script: 'Great Vibes', Clean: 'Baloo 2' };
  var INKS = { Pine: '#0E2B22', Red: '#A8372A', Gold: '#C2A049', Black: '#111111', White: '#FFFFFF', Ice: '#BFD8D1' };
  var GROUNDS = [['dark heather', '#474a51'], ['mint', '#a8e0c8'], ['atlantic', '#2b4f6e'], ['cypress', '#4a5d4f'], ['ecru', '#e9e1cf'],
    ['plum', '#5d2f4f'], ['bone', '#e8e0d0'], ['bubblegum', '#f5a3c7'], ['coal', '#333333'], ['orchid', '#b98cc2'], ['sage', '#a3b39a'],
    ['heliconia', '#e6457a'], ['butter', '#f6e3a1'], ['crimson', '#9e1b32'], ['denim', '#4f6d8f'], ['pepper', '#5a5a58'], ['espresso', '#4b3428'],
    ['heather grey', '#cfcfcf'], ['sport grey', '#bdbdbd'], ['ash', '#dcdcdc'], ['light grey', '#d6d6d6'],
    ['charcoal', '#3b3b3b'], ['dark grey', '#4a4a4a'], ['grey', '#b5b5b5'], ['gray', '#b5b5b5'], ['black', '#161616'],
    ['navy', '#1f2a44'], ['royal', '#2c4fa0'], ['light blue', '#aecbe8'], ['blue', '#3c6db3'], ['teal', '#0d6e6e'],
    ['forest', '#23402f'], ['bottle green', '#1f4d36'], ['irish green', '#2e8b57'], ['military', '#4b5320'], ['green', '#2f6b3f'],
    ['maroon', '#5a1f27'], ['burgundy', '#5e1b2b'], ['red', '#b3262e'], ['pink', '#f4c2cf'], ['purple', '#5b3a7a'],
    ['orange', '#e0762c'], ['yellow', '#f2d24b'], ['natural', '#efe6d2'], ['cream', '#f3ecdc'], ['sand', '#e3d3b4'],
    ['beige', '#e6d8bd'], ['brown', '#6b4a33'], ['white', '#ffffff']];
  var SOLID = { heart: [[0.24, 0.12, 0.76, 0.52], 0.63, 0.46], star: [[0.33, 0.28, 0.67, 0.58], 0.66, 0.36],
    hexagon: [[0.18, 0.1, 0.82, 0.68], 0.8, 0.66] };

  function ink(v) {
    v = String(v || 'Pine');
    if (v.indexOf('#') >= 0) return '#' + v.split('#')[1].slice(0, 6);
    return INKS[v] || INKS.Pine;
  }
  function ground(title, spec) {
    var t = String(title || '').toLowerCase();
    if (spec && (spec.panel === 'band' || spec.panel === 'shape')) return null;
    for (var i = 0; i < GROUNDS.length; i++) if (t.indexOf(GROUNDS[i][0]) >= 0) return GROUNDS[i][1];
    return null;
  }
  function url(src) {
    src = String(src || '').trim();
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
    return src;
  }
  /* No crossOrigin: the drawing is only shown, never read back, so any image host works. */
  function load(src) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () { res(im); }; im.onerror = rej;
      im.src = url(src);
    });
  }
  /* The four lettering faces live on the product pages only; the cart page and drawer fetch them here, once. */
  var fontsP = null;
  function fonts() {
    if (fontsP) return fontsP;
    /* The faces can only be asked for once the stylesheet declaring them has loaded; asked earlier, fonts.load
       answers at once with nothing and the name is drawn in a fallback face. */
    var l = document.querySelector('link[href*="Luckiest+Guy"]');
    var sheet = new Promise(function (res) {
      if (!l) {
        l = document.createElement('link'); l.rel = 'stylesheet'; l.onload = res; l.onerror = res;
        l.href = 'https://fonts.googleapis.com/css2?family=Luckiest+Guy&family=Bangers&family=Great+Vibes&family=Baloo+2:wght@700&display=swap';
        document.head.appendChild(l);
      } else if (l.sheet) res();
      else { l.addEventListener('load', res); l.addEventListener('error', res); }
      setTimeout(res, 2000);
    });
    var all = sheet.then(function () {
      if (!document.fonts || !document.fonts.load) return;
      return Promise.all(['40px "Luckiest Guy"', '40px "Bangers"', '40px "Great Vibes"', '700 40px "Baloo 2"'].map(function (f) {
        return document.fonts.load(f).catch(function () {});
      }));
    });
    fontsP = Promise.race([all, new Promise(function (r) { setTimeout(r, 4000); })]);
    return fontsP;
  }
  function fit(c, im, x, y, w, h) {
    var s = Math.min(w / im.naturalWidth, h / im.naturalHeight), dw = im.naturalWidth * s, dh = im.naturalHeight * s;
    c.drawImage(im, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }
  function cover(c, im, W, H) {
    var s = Math.max(W / im.naturalWidth, H / im.naturalHeight), dw = im.naturalWidth * s, dh = im.naturalHeight * s;
    c.drawImage(im, (W - dw) / 2, (H - dh) / 2, dw, dh);
  }
  function text(c, name, face, colour, cx, cy, maxW, size0) {
    var f = FACES[face] || FACES.Bold, t = (f === 'Luckiest Guy' || f === 'Bangers') ? name.toUpperCase() : name, size = size0;
    c.textAlign = 'center'; c.textBaseline = 'middle';
    var wt = f === 'Baloo 2' ? '700 ' : '';
    do { c.font = wt + size + 'px "' + f + '", system-ui, sans-serif'; size -= 2; } while (c.measureText(t).width > maxW && size > 10);
    var col = ink(colour);
    if (/^#(ffffff|c2a049)$/i.test(col)) { c.lineWidth = Math.max(2, size / 9); c.strokeStyle = '#0E2B22'; c.lineJoin = 'round'; c.strokeText(t, cx, cy); }
    c.fillStyle = col; c.fillText(t, cx, cy);
  }
  function shapePath(c, sh, W, H) {
    var s = String(sh).toLowerCase(), cx = W / 2, cy = H / 2, r = Math.min(W, H) * 0.47;
    c.beginPath();
    if (s === 'heart') {
      var w = r * 2.05, h = r * 1.9, top = cy - h * 0.42;
      c.moveTo(cx, top + h * 0.28);
      c.bezierCurveTo(cx, top, cx - w / 2, top, cx - w / 2, top + h * 0.3);
      c.bezierCurveTo(cx - w / 2, top + h * 0.6, cx, top + h * 0.8, cx, top + h);
      c.bezierCurveTo(cx, top + h * 0.8, cx + w / 2, top + h * 0.6, cx + w / 2, top + h * 0.3);
      c.bezierCurveTo(cx + w / 2, top, cx, top, cx, top + h * 0.28);
    } else if (s === 'star') {
      for (var i = 0; i < 10; i++) { var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r * 0.45 : r * 1.02; c[i ? 'lineTo' : 'moveTo'](cx + rr * Math.cos(a), cy + 0.06 * r + rr * Math.sin(a)); }
    } else if (s === 'hexagon') {
      for (var k = 0; k < 6; k++) { var b = k * Math.PI / 3; c[k ? 'lineTo' : 'moveTo'](cx + r * 1.08 * Math.cos(b), cy + r * 1.08 * Math.sin(b)); }
    } else {
      var txt = s === 'love' ? 'LOVE' : String(sh).toUpperCase(), size = H * 0.92;
      c.font = '900 ' + size + 'px "Arial Black", "Helvetica Neue", Arial, sans-serif';
      var m = c.measureText(txt);
      if (m.width > W * 0.9) { size = size * W * 0.9 / m.width; c.font = '900 ' + size + 'px "Arial Black", "Helvetica Neue", Arial, sans-serif'; m = c.measureText(txt); }
      c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      var asc = m.actualBoundingBoxAscent || size * 0.72, desc = m.actualBoundingBoxDescent || 0;
      c.fillText(txt, cx, cy + (asc - desc) / 2);
      return 'text';
    }
    c.closePath(); return 'path';
  }

  /* PHOTO BLANKETS, as sv-photo.js draws them and tools/photo_flat prints them: the border colour, a mount round the
     photo, the name under it and the Christmas line, at the blanket's own shape inside the square. */
  var BORDERS = { 'Deep pine': ['#0E2B22', '#C2A049', '#F3EDE1'], 'Christmas red': ['#7B1A1D', '#D4AF5A', '#F3EDE1'],
    'Midnight navy': ['#12223C', '#C6A85C', '#F3EDE1'], 'Charcoal': ['#1A1C1E', '#C6C6C6', '#F3EDE1'], 'Warm bone': ['#EEE8DC', '#A88538', '#5C503A'] };
  function rr(c, x, y, w, h, r) {
    c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
  }
  function drawBlanket(it, im) {
    var P = it.properties || {}, S = 600, c = document.createElement('canvas'); c.width = S; c.height = S;
    var x = c.getContext('2d'); x.fillStyle = '#F7F5F0'; x.fillRect(0, 0, S, S);
    var m = String(it.variant_title || '').match(/(\d+)\s*x\s*(\d+)/i), asp = m ? (+m[1]) / (+m[2]) : 4724 / 6567;
    var H = S - 36, W = Math.round(H * asp), ox = (S - W) / 2, oy = 18, bd = BORDERS[P.Border] || BORDERS['Deep pine'];
    x.save(); x.translate(ox, oy);
    x.shadowColor = 'rgba(0,0,0,.25)'; x.shadowBlur = 10; x.shadowOffsetY = 4; x.fillStyle = bd[0]; x.fillRect(0, 0, W, H); x.shadowColor = 'transparent';
    var mg = W * 0.085, wx = mg, wy = H * 0.085, ww = W - 2 * mg, wh = H * 0.6, pad = W * 0.016;
    x.fillStyle = bd[1]; rr(x, wx - pad, wy - pad, ww + 2 * pad, wh + 2 * pad, W * 0.022); x.fill();
    x.save(); rr(x, wx, wy, ww, wh, W * 0.016); x.clip();
    var r = Math.max(ww / im.naturalWidth, wh / im.naturalHeight), dw = im.naturalWidth * r, dh = im.naturalHeight * r;
    x.drawImage(im, wx + (ww - dw) / 2, wy + (wh - dh) / 2, dw, dh); x.restore();
    var name = String(P.Name || '').trim();
    if (name) text(x, name, P.Lettering, P['Lettering colour'] || 'Gold', W / 2, H * 0.745, W - 2 * mg, Math.round(H * 0.1));
    x.font = Math.round(H * 0.05) + 'px "Great Vibes", cursive'; x.textAlign = 'center'; x.textBaseline = 'middle';
    x.fillStyle = bd[2]; x.fillText(/pet/.test(it.handle || it.url || '') ? 'Merry Christmas' : 'Christmas 2026', W / 2, H * 0.87);
    x.restore();
    return c;
  }

  /* one line, drawn as a 600 px square */
  function drawLine(it, im) {
    var P = it.properties || {}, spec = {};
    if (P.Photo) return drawBlanket(it, im);
    try { spec = JSON.parse(P._spec || '{}') || {}; } catch (e) {}
    var W = 600, H = 600, c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d'), name = String(P.Name || '').trim(), up = !!(P['Your artwork'] || P.Photo);
    x.fillStyle = '#F7F5F0'; x.fillRect(0, 0, W, H);
    if (spec.panel === 'shape') {
      var sh = String(P.Letter || String(it.variant_title || '').split('/')[0]).replace(/^(letter|number|shape)\s+/i, '').trim();
      var lay = document.createElement('canvas'); lay.width = W; lay.height = H;
      var l = lay.getContext('2d'); l.fillStyle = '#E4C99A';
      var kind = shapePath(l, sh, W, H); if (kind === 'path') l.fill();
      l.globalCompositeOperation = 'source-atop';
      var sol = SOLID[String(sh).toLowerCase()];
      if (!sol) {
        if (up) cover(l, im, W, H);
        else {
          var mh = W * 0.26, mw = im.naturalWidth * mh / im.naturalHeight, sx = mw * 1.18, sy = mh * 1.12;
          for (var row = 0, y = -sy / 3; y < H; y += sy, row++) for (var xx = (row % 2 ? -sx / 2 : 0) - sx / 4; xx < W; xx += sx) l.drawImage(im, xx, y, mw, mh);
        }
      } else {
        var b = sol[0], y1 = name ? b[3] : (String(sh).toLowerCase() === 'star' ? 0.66 : Math.min(sol[1] + 0.08, 0.9));
        fit(l, im, W * b[0], H * b[1], W * (b[2] - b[0]), H * (y1 - b[1]));
        if (name) text(l, name, P.Lettering, P._ink || P['Lettering colour'], W / 2, H * sol[1], W * sol[2], Math.round(H * 0.1));
      }
      x.save(); x.shadowColor = 'rgba(60,40,10,.35)'; x.shadowBlur = 12; x.shadowOffsetY = 5; x.drawImage(lay, 0, 0); x.restore();
      return c;
    }
    var g = up ? null : ground(it.variant_title, spec);   /* as the product page: an upload is a photo and keeps white */
    if (g) { x.fillStyle = g; x.fillRect(0, 0, W, H); }
    var pad = 48, band = name ? 110 : 0;
    fit(x, im, pad, pad, W - pad * 2, H - pad * 2 - band);
    if (name) text(x, name, P.Lettering, P._ink || P['Lettering colour'], W / 2, H - pad - band / 2, W - pad * 2, 70);
    return c;
  }

  function source(it) {
    var P = it.properties || {};
    if (P['Your artwork'] || P.Photo) return P['Your artwork'] || P.Photo;
    if (P._sv_preview) return '';          /* sv-garment.js draws the garment itself, in its colour */
    return P._art || '';
  }

  /* ONE-DESIGN PRODUCTS WITH A NAME (sacks, stockings, mugs, towels, ornaments, bandanas). The product photo is
     Printify's mockup reading YOUR NAME, so a stocking bought for Max showed YOUR NAME in the cart. The line is drawn
     the way the product page and the builder preview it ("Your name, as it will be printed"): the design with the
     name above or under it, in the chosen lettering and ink, with the press's two rings (tools/personalise.py).
     templates/product.sv-cart.liquid answers with the product's design image, name slot and ink. */
  var INFO = {};
  function info(handle) {
    if (!INFO[handle]) INFO[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=sv-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t.trim()); }).catch(function () { return {}; });
    return INFO[handle];
  }
  var BINKS = { Pine: '#0E2B22', Gold: '#C2A049', Red: '#9B2226', White: '#FFFFFF' };   /* sv-build.js INKS */
  function lum(hex) {
    var h = String(hex || '').replace('#', ''); if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16); if (isNaN(n)) return 0;
    return ((n >> 16 & 255) * 299 + (n >> 8 & 255) * 587 + (n & 255) * 114) / 1000;
  }
  function drawFlat(it, im, inf) {
    var P = it.properties || {}, S = 600, c = document.createElement('canvas'); c.width = S; c.height = S;
    var x = c.getContext('2d');
    x.drawImage(im, 0, 0, 4, 4, 0, 0, S, S);   /* the card takes the design image's own ground, from its corner */
    var col = BINKS[P['Lettering colour']] || inf.ink || '#0E2B22', face = FACES[P.Lettering] || FACES.Bold;
    var nm = String(P.Name || '').trim(); if (face === 'Luckiest Guy' || face === 'Bangers') nm = nm.toUpperCase();
    var above = inf.slot === 'above', band = S * 0.24, pad = S * 0.05;
    fit(x, im, pad, above ? band : pad, S - 2 * pad, S - band - pad);
    var size = Math.round(band * 0.62), cy = above ? band * 0.55 : S - band * 0.55;
    x.textAlign = 'center'; x.textBaseline = 'middle';
    var wt = face === 'Baloo 2' ? '700 ' : '';
    do { x.font = wt + size + 'px "' + face + '", system-ui, sans-serif'; size -= 2; } while (x.measureText(nm).width > S * 0.9 && size > 10);
    var key = Math.max(1, size * 0.085), out = Math.max(key + 1, size * 0.1785), light = lum(col) > 150;
    x.lineJoin = 'round';
    x.strokeStyle = light ? '#FFFFFF' : '#0E161C'; x.lineWidth = out * 2; x.strokeText(nm, S / 2, cy);
    x.strokeStyle = light ? '#0E161C' : '#FFFFFF'; x.lineWidth = key * 2; x.strokeText(nm, S / 2, cy);
    x.fillStyle = col; x.fillText(nm, S / 2, cy);
    return c;
  }
  function drawSnap(im) {
    var S = 600, c = document.createElement('canvas'); c.width = S; c.height = S;
    var x = c.getContext('2d'); x.fillStyle = '#F7F5F0'; x.fillRect(0, 0, S, S); fit(x, im, 24, 24, S - 48, S - 48);
    return c;
  }
  /* what to draw a line from, or null to leave the cart's own photo */
  function plan(it) {
    var P = it.properties || {}, src = source(it);
    /* 0.46.8: the product page's own preview, attached on Add to cart: exactly what was built */
    if (P._preview) return Promise.resolve({ src: P._preview, snap: true });
    if (src) return Promise.resolve({ src: src });
    if (!P.Name || P._sv_preview || P._art) return Promise.resolve(null);
    return info(it.handle).then(function (inf) { return inf && inf.art ? { src: inf.art, flat: inf } : null; });
  }

  /* An upload beats the garment redraw. Hidden, not removed, so sv-garment.js sees its canvas and does not draw again. */
  function hideGarment(row) {
    Array.prototype.forEach.call(row.querySelectorAll('canvas.sv-cart-gcv'), function (g) { g.style.display = 'none'; });
  }
  /* sv-garment.js draws a named garment the moment the row appears, before the lettering faces have loaded on a page
     that is not a product page, so the name comes out in a fallback face. Once they load, its canvases are dropped
     (once) and sv-garment.js draws them again, the same way its own fonts.ready pass does on the product page. */
  function refreshGarments() {
    Array.prototype.forEach.call(document.querySelectorAll('canvas.sv-cart-gcv'), function (g) {
      if (g.style.display === 'none') return;
      var img = g.nextElementSibling; if (img && img.tagName === 'IMG') img.style.display = '';
      g.remove();
    });
  }
  var busy = false, again = false;
  function pass() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-key]'), function (r) { if (r.querySelector('canvas.sv-cart-acv')) hideGarment(r); });
    var rows = Array.prototype.filter.call(document.querySelectorAll('[data-key]'), function (r) {
      return r.querySelector('img, canvas.sv-cart-gcv') && !r.querySelector('canvas.sv-cart-acv');
    });
    if (!rows.length) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var by = {};
      var named = false, garb = false;
      (cart.items || []).forEach(function (it) {
        var P = it.properties || {};
        if (P.Name || P.Photo) named = true;
        if (P._sv_preview && P.Name) garb = true;
        by[it.key] = it;
      });
      if (garb && !fontsP) fonts().then(refreshGarments);
      return (named ? fonts() : Promise.resolve()).then(function () { return Promise.all(rows.map(function (row) {
        var it = by[row.getAttribute('data-key')]; if (!it) return null;
        var how = null;
        return plan(it).then(function (h) { how = h; return h ? load(h.src) : null; }).then(function (im) {
          if (!im || row.querySelector('canvas.sv-cart-acv')) return;
          var cv = how.snap ? drawSnap(im) : how.flat ? drawFlat(it, im, how.flat) : drawLine(it, im);
          cv.className = 'sv-cart-acv'; cv.setAttribute('role', 'img');
          var P = it.properties || {};
          cv.setAttribute('aria-label', (P.Letter || P.Spells ? 'Letter ' + (P.Letter || String(it.variant_title || '').split('/')[0].trim()) + ', ' : '') + (P.Design ? String(P.Design).replace(/^[A-Z]{2}\d+\s+/, '') : (P['Your artwork'] || P.Photo ? 'your own image' : it.product_title)) + (P.Name ? ', printed ' + P.Name : ''));
          cv.style.cssText = 'display:block;width:100%;height:auto;aspect-ratio:1/1;border-radius:inherit';
          var img = row.querySelector('img'); if (!img) return;
          img.style.display = 'none'; img.parentNode.insertBefore(cv, img);
          hideGarment(row);
        }).catch(function () {});
      })); });
    }).catch(function () {}).then(function () {
      busy = false; if (again) { again = false; setTimeout(pass, 60); }
    });
  }
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(pass, 300); }
  function boot() {
    soon();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:cart:lines-update', soon);
    document.addEventListener('cart:refresh', soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
